import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { Config } from './config';
import { RestClientService } from './restclient.service';
import { Recaptcha } from '../modelo/captcha';
import { Autenticado, LoginRequest } from '../modelo/autenticado';
import { Identificador } from '../modelo/identificador';
import { EnvioCodigoRequest, CodigoResponse, ValidacaoCodigoRequest } from '../modelo/tokenSmsEmail';

@Injectable()
export class LoginService {

    constructor(private restClient: RestClientService) {

    }

    validarLogin = (request: LoginRequest): Observable<Autenticado> => {
      let resourcePath = Config.NOVO_LOGIN_PATH + "/validarLogin";
      return this.restClient.postResource(resourcePath, request);
    };

    validarPrimeiroAcesso = (request: Identificador): Observable<Autenticado> => {
      let resourcePath = Config.NOVO_LOGIN_PATH + "/validarPrimeiroAcesso";
      return this.restClient.postResource(resourcePath, request);
    };

    obterReCaptcha = (): Observable<Recaptcha> => {
      let resourcePath = Config.NOVO_LOGIN_PATH + "/recuperarReCaptcha";
      return this.restClient.postResourceNoBody(resourcePath);
    };

    receberToken = (request: EnvioCodigoRequest): Observable<CodigoResponse> => {
      let resourcePath = Config.NOVO_LOGIN_PATH + "/receberTokenSmsEmail";
      return this.restClient.postResource(resourcePath, request);
    }

    validarToken = (request: ValidacaoCodigoRequest): Observable<CodigoResponse> => {
      let resourcePath = Config.NOVO_LOGIN_PATH + "/validarTokenSmsEmail";
      return this.restClient.postResource(resourcePath, request);
    }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/login.service.ts